// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "6.49.3",
  date: "2026-06-05T06:25:51.646Z",
  gitInfo: {
    dirty: false,
    raw: "36aa1508d",
    hash: "36aa1508d",
    distance: null,
    tag: null,
    semver: null,
    suffix: "36aa1508d",
    semverString: null
  }
};
/* tslint:enable */
